import {buttonBaseClasses, linkClasses, ThemeOptions, Breakpoints} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiModal = ({modal, focus}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => ({
  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(25, 25, 26, 0.7)'
      },
      invisible: {
        backgroundColor: 'transparent'
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      root: {
        [mediaQueries.down('sm')]: {
          '> .MuiDialog-container.MuiDialog-scrollPaper': {
            height: modal.container.mobile.height,
            position: 'absolute',
            width: '100%',
            bottom: 0
          }
        }
      },
      paper: {
        borderRadius: modal.container.desktop.border.radius.all,
        backgroundColor: modal.container.desktop.background.color,
        boxShadow: modal.container.desktop.boxShadow,
        [mediaQueries.down('sm')]: {
          padding: modal.container.mobile.padding.all,
          borderRadius: 0
        },
        [mediaQueries.up('sm')]: {
          width: 'auto',
          height: 'auto'
        }
      },
      paperWidthXs: {},
      paperWidthSm: {
        maxWidth: modal.container.sm.desktop.maxWidth,
        padding: modal.container.sm.desktop.padding.all
      },
      paperWidthMd: {
        maxWidth: modal.container.md.desktop.maxWidth,
        padding: modal.container.md.desktop.padding.all
      },
      paperWidthLg: {
        maxWidth: modal.container.lg.desktop.maxWidth,
        padding: modal.container.lg.desktop.padding.all
      },
      paperWidthXl: {
        maxWidth: modal.container.xl.desktop.maxWidth,
        padding: modal.container.xl.desktop.padding.all
      }
    }
  },
  MuiDialogTitle: {
    defaultProps: {},
    styleOverrides: {
      root: {
        [`.${buttonBaseClasses.root}:focus-within, .${linkClasses.root}:focus-within`]: {
          outline: `${focus.outline.width} ${focus.outline.style} ${focus.outline.color}`
        }
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        marginBottom: 16,
        padding: 0
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        justifyContent: 'flex-start',
        marginTop: 16,
        padding: 0
      }
    }
  }
});
